import React from 'react';
import UploadSgfForm from 'forms/UploadSgfForm';

const Upload = () => {
  return <UploadSgfForm />;
};

export default Upload;
